import styled from '@emotion/styled';
const PageWrapper = styled.div`
  min-height: 100vh;
`;

const PageHeader = styled.div`
  padding: 1rem 0;
  margin-bottom: 1rem;
  border-radius: 0.375rem;
  background-color: var(--phoenix-white);
  border-bottom: 1px solid var(--phoenix-200);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  position: sticky;
  top: 64px;
  z-index: 10;

  @media (min-width: 768px) {
    padding: 1.5rem 0;
    margin-bottom: 2rem;
  }
`;

const PageTitle = styled.h1`
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--phoenix-800);
  margin-bottom: 0.25rem;
  display: flex;
  align-items: center;

  @media (min-width: 768px) {
    font-size: 1.5rem;
    margin-bottom: 0.5rem;
  }
`;

const PageDescription = styled.p`
  color: var(--phoenix-600);
  margin-bottom: 0;
  font-size: 0.875rem;

  @media (min-width: 768px) {
    font-size: 1rem;
  }
`;

const Card = styled.div`
  background-color: var(--phoenix-white);
  border-radius: 0.5rem;
  /* box-shadow:
    0 1px 3px rgba(0, 0, 0, 0.05),
    0 1px 2px rgba(0, 0, 0, 0.1); */
  margin-bottom: 1rem;
  border: 1px solid var(--phoenix-200);
  overflow: hidden;
  transition: all 0.2s ease;

  @media (min-width: 768px) {
    border-radius: 0.75rem;
    margin-bottom: 1.5rem;
  }
`;

const CardHeader = styled.div`
  background-color: var(--phoenix-white);
  border-bottom: ${props =>
    props.isExpanded ? '1px solid var(--phoenix-200)' : 'none'};
  padding: 0.75rem 1rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.5rem;

  @media (min-width: 768px) {
    padding: 1rem 1.25rem;
    flex-wrap: nowrap;
  }
`;

const CardBody = styled.div`
  padding: 0;
`;

const SectionTitle = styled.h2`
  font-size: 1rem;
  font-weight: 600;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: var(--phoenix-900);
  flex: 1;
  min-width: 0;

  @media (min-width: 768px) {
    font-size: 1.125rem;
  }
`;

const SectionIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.75rem;
  height: 1.75rem;
  border-radius: 0.375rem;
  background-color: var(--phoenix-100);
  color: #64748b;

  @media (min-width: 768px) {
    width: 2rem;
    height: 2rem;
    border-radius: 0.5rem;
  }
`;

const ActionItem = styled.div`
  padding: 0.75rem 1rem;
  border-bottom: 1px solid var(--phoenix-200);
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  transition: background-color 0.2s ease;
  background-color: ${props =>
    props.level % 2 === 0 ? 'var(--phoenix-white)' : 'var(--phoenix-white)'};

  &:hover {
    background-color: var(--phoenix-200);
  }

  &:last-child {
    border-bottom: none;
  }

  @media (min-width: 768px) {
    padding: 0.75rem 1.25rem;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
`;

const ActionName = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex: 1;
  min-width: 0;
`;

const ActionControls = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
  margin-left: 1.5rem;

  @media (min-width: 768px) {
    justify-content: flex-end;
    margin-left: 0;
  }
`;

const IndentedContent = styled.div`
  margin-left: ${props => props.level * 1}rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex: 1;
  min-width: 0;

  @media (min-width: 768px) {
    margin-left: ${props => props.level * 1.5}rem;
  }
`;

const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0;
  cursor: pointer;
  font-weight: 500;
  color: var(--phoenix-600);
  font-size: 0.875rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (min-width: 768px) {
    font-size: 0.9375rem;
  }
`;

const RoleSelector = styled.div`
  position: relative;
  width: 100%;
  max-width: 300px;
  z-index: 20;
`;

const RoleButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-width: 150px;
  padding: 0.5rem 0.75rem;
  background-color: var(--phoenix-white);
  border: 1px solid var(--phoenix-200);
  border-radius: 0.375rem;
  color: var(--phoenix-800);
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.875rem;

  &:hover {
    border-color: var(--phoenix-400);
    background-color: var(--phoenix-100);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
    border-color: var(--phoenix-primary);
  }

  @media (min-width: 768px) {
    padding: 0.625rem 1rem;
    font-size: 0.9375rem;
  }
`;

const RoleDropdown = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background-color: var(--phoenix-white);
  border: 1px solid var(--phoenix-200);
  border-radius: 0.375rem;
  margin-top: 0.25rem;
  box-shadow:
    0 4px 6px rgba(0, 0, 0, 0.05),
    0 1px 3px rgba(0, 0, 0, 0.1);
  z-index: 20;
  display: ${props => (props.isOpen ? 'block' : 'none')};
  max-height: 200px;
  overflow-y: auto;
`;

const RoleOption = styled.div`
  padding: 0.5rem 0.75rem;
  cursor: pointer;
  transition: all 0.2s ease;
  background-color: ${props =>
    props.isActive ? 'var(--phoenix-primary-100)' : 'transparent'};
  color: ${props =>
    props.isActive ? 'var(--phoenix-primary)' : 'var(--phoenix-800)'};
  font-weight: ${props => (props.isActive ? '600' : '400')};
  font-size: 0.875rem;

  &:hover {
    background-color: var(--phoenix-200);
  }

  &:first-of-type {
    border-top-left-radius: 0.375rem;
    border-top-right-radius: 0.375rem;
  }

  &:last-of-type {
    border-bottom-left-radius: 0.375rem;
    border-bottom-right-radius: 0.375rem;
  }

  @media (min-width: 768px) {
    padding: 0.625rem 1rem;
    font-size: 0.9375rem;
  }
`;

const SaveButton = styled.button`
  padding: 0.5rem 0.75rem;
  border-radius: 0.375rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 600;
  background-color: var(--phoenix-primary);
  color: #ffffff;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.875rem;

  &:hover {
    background-color: var(--phoenix-primary-500);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.4);
  }

  @media (min-width: 768px) {
    padding: 0.625rem 1.25rem;
    font-size: 0.9375rem;
  }
`;

const ActionButton = styled.button`
  padding: 0.5rem;
  border-radius: 0.375rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--phoenix-100);
  color: var(--phoenix-1000);
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: var(--phoenix-300);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
  }
`;

const SearchInput = styled.div`
  position: relative;
  width: 100%;
  margin-bottom: 1rem;

  @media (min-width: 768px) {
    max-width: 400px;
    margin-bottom: 1.5rem;
  }
`;

const SearchIcon = styled.div`
  position: absolute;
  left: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  color: #94a3b8;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Input = styled.input`
  width: 100%;
  padding: 0.625rem 0.75rem 0.625rem 2.25rem;
  border-radius: 0.375rem;
  border: 1px solid var(--phoenix-200);
  background-color: var(--phoenix-white);
  color: var(--phoenix-800);
  font-size: 0.875rem;
  transition: all 0.2s ease;

  &:focus {
    outline: none;
    border-color: var(--phoenix-primary);
  }

  &::placeholder {
    color: #94a3b8;
  }

  @media (min-width: 768px) {
    padding: 0.75rem 1rem 0.75rem 2.5rem;
  }
`;

const NoResults = styled.div`
  padding: 1.5rem;
  text-align: center;
  color: var(--phoenix-700);
  font-weight: 500;
  background-color: var(--phoenix-white);
  border-radius: 0.5rem;
  border: 1px solid var(--phoenix-200);

  @media (min-width: 768px) {
    padding: 2rem;
    border-radius: 0.75rem;
  }
`;

const ActionBadge = styled.div`
  background-color: ${props =>
    props.isActive ? 'var(--phoenix-primary)' : 'var(--phoenix-100)'};
  color: ${props => (props.isActive ? '#ffffff' : 'var(--phoenix-600)')};
  font-weight: 500;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  margin: 0.125rem;
  transition: all 0.2s ease;
  font-size: 0.75rem;

  &:hover {
    background-color: ${props =>
      props.isActive ? 'var(--phoenix-primary-500)' : 'var(--phoenix-300)'};
  }

  @media (min-width: 768px) {
    padding: 0.375rem 0.625rem;
    border-radius: 0.375rem;
    margin: 0.25rem;
  }
`;

const ActionIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.125rem 0.375rem;
  border-radius: 9999px;
  font-size: 0.6875rem;
  font-weight: 600;
  background-color: #22c55e;
  color: #ffffff;
  margin-left: 0.375rem;

  @media (min-width: 768px) {
    padding: 0.25rem 0.5rem;
    font-size: 0.75rem;
  }
`;

const HeaderControls = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-top: 0.5rem;
  width: 100%;

  @media (min-width: 768px) {
    width: auto;
    margin-top: 0;
  }
`;

export {
  PageWrapper,
  PageHeader,
  PageTitle,
  PageDescription,
  Card,
  CardHeader,
  CardBody,
  SectionTitle,
  SectionIcon,
  ActionItem,
  ActionName,
  ActionControls,
  IndentedContent,
  CheckboxLabel,
  RoleSelector,
  RoleButton,
  RoleDropdown,
  RoleOption,
  SaveButton,
  ActionButton,
  SearchInput,
  SearchIcon,
  Input,
  NoResults,
  ActionBadge,
  ActionIcon,
  Badge,
  HeaderControls
};
